// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cacnea: PokeData = {
  "id": 331,
  "name": "cacnea",
  "height": 4,
  "weight": 513,
  "base_experience": 67,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "sand-attack",
    "poison-sting",
    "pin-missile",
    "leer",
    "absorb",
    "leech-seed",
    "growth",
    "cotton-spore",
    "feint-attack",
    "spikes",
    "destiny-bond",
    "sandstorm",
    "ingrain",
    "needle-arm",
    "bullet-seed",
    "payback",
    "assurance",
    "sucker-punch",
    "poison-jab",
    "energy-ball",
    "power-trip"
  ],
  "moves": [
    "pin-missile",
    "leer",
    "sandstorm",
    "bullet-seed",
    "poison-jab",
    "energy-ball",
    "wood-hammer",
    "grassy-terrain",
    "solar-beam",
    "frenzy-plant",
    "synthesis",
    "vine-whip",
    "aromatherapy"
  ],
  "evolution_chain": {
    "id": 167,
    "item": null,
    "species": [
      {
        "name": "cacnea",
        "order": 359,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cacturne",
        "order": 360,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": 331,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 35,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
